import { subscribeGameMessages } from "../realtime/chatChannel.js";

/**
 * @param {HTMLElement} container
 * @param {object} opts
 * @param {import('@supabase/supabase-js').SupabaseClient} opts.supabase
 * @param {string} opts.gameId
 * @param {string} opts.currentUserId
 */
export function mountChat(container, opts) {
  const { supabase, gameId, currentUserId } = opts;

  const panel = document.createElement("div");
  panel.className = "chat-panel";
  panel.innerHTML = `
    <h3 class="sr-only">Game chat</h3>
    <div class="chat-messages" aria-live="polite"></div>
    <form class="chat-form">
      <label class="sr-only" for="chat-input">Message</label>
      <input id="chat-input" name="body" type="text" maxlength="2000" autocomplete="off" placeholder="Message…" />
      <button type="submit">Send</button>
    </form>
  `;

  const messagesEl = panel.querySelector(".chat-messages");
  const form = panel.querySelector("form");
  const input = panel.querySelector("input");

  function appendLine(text, isSelf) {
    const div = document.createElement("div");
    div.className = "chat-msg";
    div.textContent = (isSelf ? "You: " : "Them: ") + text;
    messagesEl?.appendChild(div);
    messagesEl?.scrollTo(0, messagesEl.scrollHeight);
  }

  async function loadHistory() {
    const { data, error } = await supabase
      .from("messages")
      .select("id, body, user_id, created_at")
      .eq("game_id", gameId)
      .order("created_at", { ascending: true })
      .limit(200);
    if (error || !messagesEl) return;
    messagesEl.replaceChildren();
    (data ?? []).forEach((row) => {
      appendLine(String(row.body), row.user_id === currentUserId);
    });
  }

  loadHistory();

  const unsub = subscribeGameMessages(supabase, gameId, (row) => {
    appendLine(String(row.body), row.user_id === currentUserId);
  });

  form?.addEventListener("submit", async (e) => {
    e.preventDefault();
    const body = String(input?.value ?? "").trim();
    if (!body) return;
    const { error } = await supabase.from("messages").insert({
      game_id: gameId,
      user_id: currentUserId,
      body,
    });
    if (!error && input) input.value = "";
  });

  container.appendChild(panel);

  return () => {
    unsub();
    panel.remove();
  };
}
